module.exports = __webpack_public_path__ + "img/Organize-Event.33bea132.svg";